var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(!!_vm.type)?_c('div',{staticClass:"sign-in-popup"},[_c('div',{staticClass:"popup-box-container"},[_c('div',{staticClass:"popup-box"},[_c('img',{class:[
          'icon',
          {
            guide: _vm.type === 'guide' || _vm.type === 'success' || _vm.type === 'fail'
          }],attrs:{"src":_vm.icon,"alt":""}}),_c('p',{class:{'notguide': _vm.type === 'success' || _vm.type === 'fail'},domProps:{"innerHTML":_vm._s(_vm.text)}})]),_vm._t("default",function(){return [_c('img',{staticClass:"close-icon",attrs:{"src":_vm.closeIcon,"alt":""},on:{"click":_vm.close}})]})],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }